import { Component, computed, input } from '@angular/core';
import { DropdownMultiselectItem } from '@bayclubs/drop-down';
import { CampCategory } from '../../models/camp-category.model';
import { CampType } from '../../models/camp-type.model';

@Component({
    selector: 'app-camp-type-section',
    standalone: false,
    templateUrl: './camp-type-section.component.html',
    styleUrl: './camp-type-section.component.scss',
})
export class CampTypeSectionComponent {
    campType = input.required<CampType>();
    selectedParentCategories = input.required<DropdownMultiselectItem[]>();

    categoriesToDisplay = computed(() => {
        const selectedType = this.campType();
        const selectedCategories = this.selectedParentCategories();

        const categoriesToDisplay: CampCategory[] = selectedType.campCategories.filter((cat) => {
            return selectedCategories.some((sc) => sc.id === cat.id);
        });

        categoriesToDisplay.sort((a, b) => a.name.localeCompare(b.name));
        return categoriesToDisplay;
    });
}
